<template>
  <div class="dashboard-card" :class="contStyle" @click="itemClick">
    <div class="card-visual">
      <div :class="imageCheck" :style="backgroundImage">
        <span class="card-del" @click="onDelete"></span>
        <div class="dim"></div>
        <div class="none-cont">
          <img src="@/assets/images/icon-card-none.svg" alt=""><br>
          현재 이미지를 표시할 수 없습니다.<br>
          뷰저블 상태를 확인해 주세요.
        </div>
      </div>
    </div>
    <div class="card-content">
      <h3>{{data.testName}}</h3>
      <ul>
        <li>
          <span>뷰저블 상태</span>
          <span class="tip-icon">
            <img src="@/assets/images/icon-card-tooltip.svg" alt="">
            <div>시작 사이트 URL에 해당하는 뷰저블 리포트(Simple / Exact / Start)가 활성화되어야 합니다.</div>
          </span>
          <span class="state" :class="stateComputed.color">{{stateComputed.text}}</span>
        </li>
        <li>
          <span>등록 일자</span> {{data.regDate | dashDate}}
        </li>
        <li>
          <span>UT 배포상태</span>
          <span class="tip-icon">
            <img src="@/assets/images/icon-card-tooltip.svg" alt="">
            <div>시작 사이트 URL에 해당하는 뷰저블 리포트(Simple / Exact / Start)가 활성화되어야 합니다.</div>
          </span>
          {{data.startDate | dotDate}}
          <span class="list-check" :class="stateComputed.deploy ? 'active' : ''" @click="onClickToggle"></span>
        </li>
      </ul>
      <div class="btn-position">
        <button-item :btnText="'조회'" :btnClass="'check'" v-if="this.data.state !== 'wait'" @click="onClickResult"/>
        <button-item :btnText="'수정'" :btnClass="'modify'" v-if="this.data.state === 'wait'" @click="onClickEdit"/>
        <button-item :btnText="'Link'" :btnClass="'link'" v-if="this.data.state !== 'wait'" @click="onClickLink"/>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonItem from '@/components/ui/button'

import { create } from 'vue-modal-dialogs'

import DistributionPop from '@/components/layerpop/distributionPop'
import LinkLayerPop from '@/components/layerpop/LinkLayerPop'
import { deleteUt, setStateChangeUt } from '@/api/ut'

const utLayer = create(DistributionPop, 'type')
const linkLayer = create(LinkLayerPop, 'data')

export default {
  name: 'DashboardPane',
  components: {
    ButtonItem
  },
  props: {
    imageCheck: {
      type: String,
      default: 'visual'
    },
    contStyle: {
      type: String,
      default: 'cont'
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  created () {

  },
  destroyed () {
  },
  computed: {
    backgroundImage () {
      const image = this.data.capture
      if (image) {
        return { 'background-image': 'url(' + image + ')' }
      } else {
        return null
      }
    },
    stateComputed () {
      const reportState = this.data.reportState
      const state = this.data.state
      const STATE_RESULT = {
        state: state,
        color: '',
        text: '실행 중',
        deploy: state === 'run',
        availableDeploy: true
      }
      if (!reportState) {
        if (state === 'run') {
          STATE_RESULT.deploy = false
          STATE_RESULT.text = '수집불가'
          STATE_RESULT.color = 'red'
          STATE_RESULT.availableDeploy = false
        } else {
          STATE_RESULT.deploy = false
          STATE_RESULT.text = '등록 필요'
          STATE_RESULT.color = 'red'
          STATE_RESULT.availableDeploy = false
        }
      } else {
        if (state === 'wait') {
          STATE_RESULT.deploy = false
        }
      }

      return STATE_RESULT
    }
  },
  methods: {
    itemClick () {
      if (this.contStyle.indexOf('cont-plus') > -1) {
        this.$router.push({ name: 'add' })
      }
    },
    async onDelete () {
      const confirmResult = await utLayer('delete')
      if (confirmResult) {
        const params = {
          utid: this.data.utid
        }

        deleteUt(params).then(data => {
          console.log(data)
          if (data.success) {
            this.$emit('onDeleteUt')
          }
        })
      }
    },
    async onClickLink () {
      if (this.data.state !== 'wait') {
        linkLayer(this.data)
      }
    },
    onClickResult () {
      this.$router.push({ name: 'result_preview', params: { utid: this.data.utid } })
    },
    onClickEdit () {
      this.$router.push({ name: 'add', params: { data: this.data } })
    },
    async onClickToggle () {
      if (this.stateComputed.availableDeploy) {
        let bChangeState = false
        if (this.data.state === 'run') {
          const confirmResult = await utLayer('stop')
          if (confirmResult) {
            this.data.state = 'end'
            bChangeState = true
          }
        } else if (this.data.state === 'wait' || this.data.state === 'end') {
          const confirmResult = await utLayer('confirm')
          if (confirmResult) {
            this.data.state = 'run'
            bChangeState = true
          }
        }

        if (bChangeState) {
          setStateChangeUt(this.data).then(data => {
            if (data.success) {

            }
          })
        }
      }
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
  .dashboard-card {
    position: relative;
    top: 0;
    width: 270px;
    height: 470px;
    display: inline-block;
    vertical-align: top;
    background: #fff;
    box-sizing: border-box;
    border-radius: 10px;
    margin:0 30px 30px 0;
    transition: 0.3s;
    &.last-cont {margin-right: 0;}
    div {
      .card-del {
        position: absolute;
        right: 10px;
        bottom: 10px;
        z-index: 3;
        width: 32px;
        height: 32px;
        display: block;
        opacity: 0;
        border-radius: 50%;
        background: #fff url('../../assets/images/icon-card-del.svg') no-repeat center;
        transition: 0.3s;
      }
    }
    .card-visual {
      position: relative;
      width: 100%;
      height: 200px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      overflow: hidden;
      .visual {
        position: absolute;
        z-index: 1;
        left: 0; top: 0;
        width: 100%;
        height: 100%;
        background: url('../../assets/images/test.jpg') no-repeat;
        background-size: cover;
        .dim {
          position: absolute;
          z-index: 2;
          left: 0; top: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.35);
        }
        .none-cont { display: none;}
      }
      .visual-none {
        position: absolute;
        z-index: 0;
        left: 0; top: 0;
        width: 100%;
        height: 100%;
        box-shadow: inset 0 0 47px 0 rgba(190, 172, 115, 0.28);
        background: #efe5c8;
        .none-cont {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          width: 100%;
          text-align: center;
          font-size: 12px;
          font-weight: 500;
          line-height: 1.58;
          color: #667378;
          img {
            margin-bottom: 5px;
          }
        }
        .dim { display: none;}
      }
    }
    .card-content {
      box-sizing: border-box;
      padding: 15px;
      border: 1px solid rgba(0, 0, 0, 0.06);
      border-top: none;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      h3 {
        height: 35px;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.29;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: inherit;
      }
      ul {
        li {
          height: 45px;
          line-height: 45px;
          border-bottom: 1px solid #ebebeb;
          text-align: right;
          font-size: 13px;
          position: relative;
          &:first-child {
            margin-top: 15px;
            border-top: 1px solid #ebebeb;
          }
          span {
            color: #666;
            float: left;
            position: relative;
            img {
              vertical-align: middle;
              margin: -3px 0 0 5px;
            }
            &.tip-icon {
              div {
                width: 235px;
                height: 90px;
                position: absolute;
                top: -85px;
                left: 50%;
                transform: translateX(-49%);
                line-height: 1.46;
                background: #fff;
                z-index: 4;
                text-align: center;
                box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
                border-radius: 10px;
                box-sizing: border-box;
                padding: 15px 20px;
                display: none;
                &::after {
                  content: "";
                  position: absolute;
                  top: 100%;
                  left: 50%;
                  transform: translateX(-50%);
                  border-width: 5px;
                  border-style: solid;
                  border-color: #fff transparent transparent transparent;
                }
                &::before {
                  content: "";
                  position: absolute;
                  top: 100%;
                  left: 50%;
                  transform: translateX(-50%);
                  border-width: 7px;
                  border-style: solid;
                  border-color: rgba(0, 0, 0, 0.16) transparent transparent transparent;
                }
              }
            }
            &.tip-icon {
              &:hover {
                div {
                  display: block;
                }
              }
            }
          }
          .state {
            float: inherit;
            color: #57ab00;
            &.red {
              color: #ec0047;
            }
          }
          .list-check {
            position: relative;
            display: inline-block;
            float: inherit;
            width: 30px;
            height: 18px;
            top: 5px;
            border-radius: 11px;
            background: #d7d7d7;
            margin-left: 5px;
            cursor: pointer;
            &::before {
              content: "";
              position: absolute;
              top: 2px;
              left: 2px;
              width: 14px;
              height: 14px;
              box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.18);
              background-color: #fff;
              border-radius: 50%;
            }
            &.active {
              background: #3eaa08;
              &::before {
                content: "";
                position: absolute;
                top: 2px;
                left: auto;
                right: 2px;
              }
            }
          }
        }
      }
      .btn-position {
        width: 100%;
        text-align: center;
        font-size: 0;
        margin-top: 15px;
      }
    }
    &.cont-plus {
      border: solid 2px #fff;
      background-color: rgba(0, 0, 0, 0.06);
      position: relative;
      cursor: pointer;
      &::before {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        border-radius: 50%;
        width: 42px;
        height: 42px;
        background: #fff url('../../assets/images/icon-card-plus.svg') no-repeat center;
        box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.21);
        transition: 0.3s;
      }
      .card-visual, .card-content, .btn-position { display: none;}
      &:hover {
        box-shadow: none;
        &::before {
           box-shadow: 0 8px 12px -4px rgba(0, 0, 0, 0.26);
        }
      }
    }
    &:hover {
      box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.27), 0 0 0 1px rgba(0, 0, 0, 0.06);
      .card-visual {
        div {
          .card-del {
            opacity: 1;
            cursor: pointer;
            &:hover {
              background: #f0f0f0 url('../../assets/images/icon-card-del.svg') no-repeat center;
            }
          }
        }
      }
    }
  }

@media all and (max-width: 990px) {
    .dashboard-card {
      width: calc(33.3% - 20px);
      &.last-cont {
        margin-right: 0;
        right: 0;
      }
    }
}
</style>
